import { render, staticRenderFns } from "./IconCircleDouble.vue?vue&type=template&id=1225acf9&"
import script from "./IconCircleDouble.vue?vue&type=script&lang=js&"
export * from "./IconCircleDouble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports